import { useCompanySettings } from '../../../company-settings/api/use-company-settings';

export const useShortSkillDescriptionsPreferred = (): boolean => {
    const { data: companySettings } = useCompanySettings();

    return companySettings?.preferShortSkillDescriptions ?? false;
};
